import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';

/**
 * The outer frame every cost breakdown shares: a titled, ruled header over a
 * stack of sections.
 *
 * `className` carries the consumer's own width — the four EU breakdowns have
 * drifted to three different minimums and each one is pinned by a DOM-identity
 * snapshot, so the width is a prop rather than a decision taken here.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title - already translated by the caller
 * @param {Object} [props.icon] - FontAwesome icon definition
 * @param {string} [props.className] - width and any other outer classes
 * @param {React.ReactNode} props.children - the sections
 */
export default function CgBreakdownShell({
  title,
  icon = faCalculator,
  className = 'min-w-[300px]',
  children,
}) {
  return (
    <div className={`space-y-3 ${className}`}>
      <div className="border-b border-gray-200 pb-2">
        <p className="text-sm font-semibold text-gray-800 flex items-center gap-2">
          <FontAwesomeIcon
            icon={icon}
            className="text-primaryColor"
          />
          {title}
        </p>
      </div>
      {children}
    </div>
  );
}
